import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail, Flame } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  const navItems = [
    { id: 'inicio', label: 'Inicio' },
    { id: 'nosotros', label: 'Nosotros' },
    { id: 'servicios', label: 'Servicios' },
    { id: 'productos', label: 'Productos' },
    { id: 'galeria', label: 'Galería' },
    { id: 'contacto', label: 'Contacto' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        {/* Top bar con info de contacto */}
        <div className="hidden md:flex items-center justify-end py-2 border-b border-gray-200 text-sm">
          <a
            href="tel:+573184476101"
            className="flex items-center gap-2 mr-6 text-gray-600 hover:text-orange-600 transition-colors"
          >
            <Phone size={16} />
            <span>318 447 6101</span>
          </a>
          <a
            href="mailto:acsegcontraincendios@gmail.com"
            className="flex items-center gap-2 text-gray-600 hover:text-orange-600 transition-colors"
          >
            <Mail size={16} />
            <span>acsegcontraincendios@gmail.com</span>
          </a>
        </div>

        {/* Main navigation */}
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('inicio')}
            className="flex items-center gap-3 group cursor-pointer"
          >
            <div className="bg-gradient-to-br from-orange-500 to-orange-600 p-2 rounded-lg shadow-md group-hover:shadow-lg transition-all">
              <Flame className="text-white" size={28} />
            </div>
            <div className="text-left">
              <h1 className="text-xl md:text-2xl font-bold text-gray-900 leading-tight">
                Adriana Calero
              </h1>
              <p className="text-xs md:text-sm text-orange-600 font-medium">
                Seguridad Contra Incendios
              </p>
            </div>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="px-4 py-2 text-gray-700 hover:text-orange-600 font-medium transition-colors relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-600 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
            <Button
              onClick={() => scrollToSection('contacto')}
              className="ml-4 bg-orange-600 hover:bg-orange-700 text-white"
            >
              Contáctanos
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-orange-600 transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <nav className="lg:hidden pb-4 border-t border-gray-200 mt-2">
            <div className="flex flex-col gap-2 pt-4">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="px-4 py-3 text-left text-gray-700 hover:text-orange-600 hover:bg-orange-50 rounded-lg font-medium transition-all"
                >
                  {item.label}
                </button>
              ))}
              <Button
                onClick={() => scrollToSection('contacto')}
                className="mt-2 bg-orange-600 hover:bg-orange-700 text-white"
              >
                Contáctanos
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;